import ButtonComponent from './ButtonComponent';

const ToggleButtonsComponent = `
  <div class='flex items-center justify-between border-b-2 border-gray-100 py-6'>
    <div class='flex justify-start lg:w-0 lg:flex-1 space-x-4'>
      ${ButtonComponent('show all', 'window.esgReaderInstance.showAllEsgItems()')}
      ${ButtonComponent('hide all', 'window.esgReaderInstance.closeAllEsgItems()')}
    </div>
    <div class='justify-end md:flex md:flex-1 lg:w-0 space-x-4'>
      ${ButtonComponent('Structure info', 'window.esgReaderInstance.toggleStructureInfo()')}
    </div>
  </div>
`;

export default ToggleButtonsComponent;
